'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/web.url-search-params.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/web.url-search-params.js
// module id = 757
// module chunks = 13